import client from '@/api/server';
import { TVGuideFeedQuery, TVGuideDStvQuery } from '@/types/tvGuide';
import { TvGuideFeed } from '@/api/validators/tvGuideFeed';
import { TvGuideDStv } from '@/api/validators/tvGuideDStv';
import { ActionContext } from '@/store/types';
import { State } from '..';

export const stateTv = {
  tvGuideFeed: [] as TvGuideFeed,
  tvGuideDStv: undefined as TvGuideDStv | undefined,
};

export const mutationsTv = {
  setTvGuideFeed(state: State, schedule: TvGuideFeed) {
    state.tvGuideFeed = schedule;
  },
  setTvGuideDStv(state: State, schedule: TvGuideDStv) {
    state.tvGuideDStv = schedule;
  },
};

export const actionsTv = {
  async fetchTvGuideFeed(
    context: ActionContext,
    payload: [TVGuideFeedQuery],
  ) {
    const [ query ] = payload;
    const schedule = await client.fetchFeedTvGuide(query);
    context.commit('setTvGuideFeed', schedule);
  },
  async fetchTvGuideDStv(
    context: ActionContext,
    payload: [TVGuideDStvQuery],
  ) {
    const [ query ] = payload;
    const schedule = await client.fetchDStvTvGuide(query);
    context.commit('setTvGuideDStv', schedule);
  },
};
